// Copyright 2016-2017 Rigo Investment Sagl.

export const poolsList = {
  list: {},
  lastFetchRange: {
    chunk: {
      key: 0,
      total: 0,
      progress: 0,
      toBlock: 0,
      fromBlock: 0
    },
    startBlock: 0,
    lastBlock: 0
  }
}
